module.exports = __webpack_public_path__ + "PTMETTAabout-2.33a2315b.png";